<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入名称" allow-clear @pressEnter="search"/>
              </a-form-item>
            </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="食物分类" prop="categoryId">
                  <a-select v-model="queryParam.categoryId" allow-clear>
                    <a-select-option v-for="item in foodCategory" :value="item.id" :key='item.id'>{{item.dictLabel}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            <template>
              <a-col :md="8" :sm="24">
                <a-form-item label="食谱分类" prop="recipeId">
                  <a-select v-model="queryParam.recipeId" allow-clear>
                    <a-select-option v-for="item in foodRecipe" :value="item.id" :key='item.id'>{{item.dictLabel}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>

            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['food:food:add']">
          <a-icon type="plus" />新增
        </a-button>

        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['food:food:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="batchUpdate(1)" v-hasPermi="['goods:goodsinfo:edit']">
          <a-icon type="edit" />批量推荐
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="batchUpdate(0)" v-hasPermi="['goods:goodsinfo:edit']">
          <a-icon type="edit" />批量不推荐
        </a-button>
        <!-- <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" /> -->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="isRecommend" slot-scope="text, record">

            <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmStatus(record, record.isRecommend)"
            @cancel="cancelStatus(record, record.isRecommend)"
          >
            <span slot="title"
              ><b>{{ record.isRecommend == '1' ? '不推荐' : '推荐' }} </b>?</span
            >

            <a-switch checked-children="推荐" un-checked-children="不推荐" :checked="record.isRecommend == '1'" />
          </a-popconfirm>

        </span>
        <span slot="quantity" slot-scope="text, record">
          {{record.quantity}}{{record.unit}}
        </span>
        <span slot="image" slot-scope="text, record">
           <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.image"
                :src="record.image" preview="头像"/>
        </span>
        <span slot="operation" slot-scope="text, record, index">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['food:food:edit']">
            <a-icon type="edit" />修改
          </a>
          <br>
          <a @click="handleDelete(record, index)" v-hasPermi="['food:food:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
// import { pageFood,listFood, delFood,editRecommend } from '@/api/food/food'

import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {getDicts} from "@/api/system/dict/data";


export default {
  name: 'Food',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      foodCategory:[],
      foodRecipe:[],
      ids: [],
       //索引indexs
      indexs: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        name: null,
        image: null,
        cookTime: null,
        categoryId: null,
        recipeId: null,
        type: null,
        kilocalorie: null,
        kilojoule: null,
        proteinWeight: null,
        proteinRatio: null,
        carbohydrateWeight: null,
        carbohydrateRatio: null,
        fatWeight: null,
        fatRatio: null,
        quantity: null,
        ricePortion: null,
        walkingDistance: null,
        characteristic: null,
        foodMaterial: null,
        practice: null,
        browserNum: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        // {
        //   title: '编号',
        //   dataIndex: 'id',
        //   align: 'center'
        // },
        {
          title: '名称',
          dataIndex: 'name',
          align: 'center'
        },
        {
          title: '图片',
          dataIndex: 'image',

          scopedSlots: {customRender: 'image'},
          align: 'center'
        },
        // {
        //   title: '制作时长 分钟',
        //   dataIndex: 'cookTime',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '食物分类',
          dataIndex: 'categoryName',
          align: 'center'
        },
        {
          title: '食谱分类',
          dataIndex: 'recipeName',
          align: 'center'
        },
        {
          title: '食物类型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f==1){
              return '绿灯'
            }else if(f==2){
              return '黄灯'
            }else{
              return '红灯'
            }
          }
        },
        {
          title: '千卡',
          dataIndex: 'kilocalorie',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '基础千焦',
        //   dataIndex: 'kilojoule',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '蛋白质g',
          dataIndex: 'proteinWeight',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '基础蛋白质含量百分比%',
        //   dataIndex: 'proteinRatio',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '碳水',
          dataIndex: 'carbohydrateWeight',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '基础碳水化合物含量百分比%',
        //   dataIndex: 'carbohydrateRatio',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '脂肪g',
          dataIndex: 'fatWeight',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '基础脂肪含量百分比%',
        //   dataIndex: 'fatRatio',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '份量',
          dataIndex: 'quantity',
          ellipsis: true,
          scopedSlots: { customRender: 'quantity' },
          align: 'center'
        },
        {
          title: '推荐',
          dataIndex: 'isRecommend',

          align: 'center',
          scopedSlots: { customRender: 'isRecommend' }
        },
        // {
        //   title: '消耗需要步行距离',
        //   dataIndex: 'walkingDistance',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '特点',
        //   dataIndex: 'characteristic',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '食材[{name:124,weight:13}]',
        //   dataIndex: 'foodMaterial',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '做法',
        //   dataIndex: 'practice',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '浏览量',
        //   dataIndex: 'browserNum',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 120,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.initDict()
  },
  activated() {
    this.initDict()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    batchUpdate(status) {
       this.selectedRowKeys.forEach((item,i)=>{
         item=parseInt(item)

      })
      console.log(this.selectedRowKeys,"selectedRowKeys")
      editRecommend({ ids: this.selectedRowKeys, isRecommend: status }).then((res) => {
        if (res.success) {
          this.$message.success('操作成功')
          this.getList()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    confirmStatus(record, status) {
      status = status == 1 ? 0 : 1
      editRecommend({ ids: [record.id], isRecommend: status}).then((res) => {
        if (res.success) {
          this.$message.success('操作成功')
          this.getList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    cancelStatus(record, status) {
      // unmount({id:record.id,status:status}).then(res=>{
      //   if(res.success){
      //     this.$message.success("操作成功")
      //     this.getList()
      //   }else{
      //     this.$message.error(res.message)
      //   }
      // })
    },
     search() {
          // 执行查询操作
        this.handleQuery ()
          // 在这里执行实际的查询逻辑
        },
    /** 查询食物信息列表 */
    getList () {
      this.loading = true
     pageFood(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },

    handleUpdate(record){
      this.$router.push({
        path: '/food/info',
        query: {
          id:record.id
        }
      })
    },
    initDict(){
      getDicts('food_category').then(res=>{
        this.foodCategory = res.data
      })
      getDicts('food_recipe').then(res=>{
        this.foodRecipe = res.data
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        image: undefined,
        cookTime: undefined,
        categoryId: undefined,
        recipeId: undefined,
        type: undefined,
        kilocalorie: undefined,
        kilojoule: undefined,
        proteinWeight: undefined,
        proteinRatio: undefined,
        carbohydrateWeight: undefined,
        carbohydrateRatio: undefined,
        fatWeight: undefined,
        fatRatio: undefined,
        quantity: undefined,
        ricePortion: undefined,
        walkingDistance: undefined,
        characteristic: undefined,
        foodMaterial: undefined,
        practice: undefined,
        browserNum: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
        // 列表顶部删除indexs
        if(this.selectedRowKeys.length){
        const indexList = this.selectedRowKeys.map(item=>{
          return this.list.findIndex(i=>i.id === item)
        })
        this.indexs = indexList.filter(item=>item!==-1).map(ind=>{
          return (this.current - 1) * this.size + ind + 1
        })
      }
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row,index) {
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if(row.id){
                data.push({"id":row.id})
              }else {
                that.ids.map(id => data.push({"id":id}))
              }
          return delFood(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('food/food/export', {
            ...that.queryParam
          }, `食物信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
